import { pdPolicyHTML } from '@webapp/landing/src/components/ru/docs/html/pd-policy';

import { Doc } from './doc';

export const PdPolicy: FC = () => <Doc html={pdPolicyHTML} subTitle='Политика ПДн' title='Оферта, договоры' />;
